import script from "./groupList.vue?vue&type=script&setup=true&lang=ts"
export * from "./groupList.vue?vue&type=script&setup=true&lang=ts"

import "./groupList.vue?vue&type=style&index=0&id=b5ebe9d2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5ebe9d2"]])

export default __exports__